import React from 'react';

const SIZES = {
  sm: 'w-4 h-4 border-2',
  md: 'w-8 h-8 border-2',
  lg: 'w-12 h-12 border-4',
};

// CSS-only spinner per shared-docs/frontend-architecture.md.
// role="status" + aria-label so screen readers announce loading.
export default function LoadingSpinner({ size = 'md', className = '' }) {
  return (
    <div className={['flex items-center justify-center py-8', className].join(' ')}>
      <div
        role="status"
        aria-label="Loading"
        className={[
          'rounded-full border-gray-200 border-t-primary-600 animate-spin',
          'dark:border-night-card dark:border-t-primary-400',
          SIZES[size] || SIZES.md,
        ].join(' ')}
      />
    </div>
  );
}
